import { createRouter, createWebHistory } from 'vue-router'
import { useMainStore } from '../pinia/main';
import Login from '../views/login.vue'
import Layout from '../components/layout/index.vue'
import Home from '../views/home.vue'
import Invoice from '../views/invoice.vue'
import Shipments from '../views/shipments.vue'
import Order from '../views/order.vue'
import Evaluate from '../views/evaluate.vue'
import ProtocolManagement from '../views/protocol_management/index.vue'
import Protocol from '../views/protocol_management/protocol.vue'
import TMap from '../views/map.vue'
import MessageNotification from '../views/mine/message_notification.vue'
import ProtocolManagementDetail from '../views/mine/message_notification_detail.vue'
import PersonalInformation from '../views/mine/personal_information.vue'
import PrivacyPolicy from '../views/mine/privacypolicy.vue'
import Auth from '../views/auth.vue'
import MyContract from '../views/mine/mycontract.vue'
import MyContractDetail from '../views/mine/my_contract_detail.vue'
import AccountSecurity from '../views/mine/account_security.vue'
import Ordinary from '../views/shipments/ordinary.vue'
import ShipmentsDetail from '../views/shipments/shipments_detail.vue'
import OrderDetail from '../views/order/orderdetail.vue'
import EvaluateDetail from '../views/evaluate/evaluatedetail.vue'
import Backlog from '../views/mine/backlog.vue'
import DriverAgreement from '../views/mine/driver_agreement.vue'
import StatementAccount from '../views/home/statement_account.vue'
import StatementAccountDetail from '../views/home/statement_account_detail.vue'
import Recharge from '../views/home/recharge.vue'
import PersonalProfile from '../views/order/personal_profile.vue'
import OpenInvoiceDetail from '../views/invoice/open_invoice_detail.vue'
import InvoiceHistoryDetail from '../views/invoice/invoice_history_detail.vue'
import MonthInvoiceHistoryDetail from '../views/invoice/month_invoice_history_detail.vue'
import ServicePhone from '../views/mine/service_phone.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/layout',
    name: 'layout',
    component: Layout,
    redirect: '/layout/home',
    children: [

      {
        path: 'home',
        name: 'home',
        component: Home,
      },
      {
        path: 'invoice',
        name: 'invoice',
        component: Invoice,
      },

      {
        path: 'shipments',
        name: 'shipments',
        component: Shipments,
      },
      {
        path: 'auth',
        name: 'auth',
        component: Auth,
      },
      {
        path: 'order',
        name: 'order',
        component: Order,
      },
      {
        path: 'evaluate',
        name: 'evaluate',
        component: Evaluate,
      },

      {
        path: 'map',
        name: 'map',
        component: TMap,
      },
      {
        path: 'messagenotification',
        name: 'messagenotification',
        component: MessageNotification,
      },  {
        path: 'invoicehistorydetail',
        name: 'invoicehistorydetail',
        component: InvoiceHistoryDetail,
      },
       {
        path: 'MonthInvoiceHistoryDetail',
        name: 'monthinvoicehistorydetail',
        component: MonthInvoiceHistoryDetail,
      },
      {
        path: 'messagenotificationdetail',
        name: 'messagenotificationdetail',
        component: ProtocolManagementDetail,
      }, {
        path: 'personalinformation',
        name: 'personalinformation',
        component: PersonalInformation,
      }, {
        path: 'privacypolicy',
        name: 'privacypolicy',
        component: PrivacyPolicy,
      },
      {
        path: 'mycontract',
        name: 'mycontract',
        component: MyContract,
      },  {
        path: 'servicephone',
        name: 'servicephone',
        component: ServicePhone,
      },
      
      
      {
        path: 'mycontractdetail',
        name: 'mycontractdetail',
        component: MyContractDetail,
      }, {
        path: 'accountsecurity',
        name: 'accountsecurity',
        component: AccountSecurity,
      },
      {
        path: 'ordinary',
        name: 'ordinary',
        component: Ordinary,
      }, {
        path: 'shipmentsdetail',
        name: 'shipmentsdetail',
        component: ShipmentsDetail,
      },
      {
        path: 'orderdetail',
        name: 'orderdetail',
        component: OrderDetail,
      },
      {
        path: 'evaluatedetail',
        name: 'evaluatedetail',
        component: EvaluateDetail,
      }, {
        path: 'backlog',
        name: 'backlog',
        component: Backlog,
      }, {
        path: 'driveragreement',
        name: 'driveragreement',
        component: DriverAgreement,
      }, {
        path: 'statementaccount',
        name: 'statementaccount',
        component: StatementAccount,
      }, {
        path: 'statementaccountdetail',
        name: 'statementaccountdetail',
        component: StatementAccountDetail,
      },
      {
        path: 'recharge',
        name: 'recharge',
        component: Recharge,
      }, {
        path: 'personalprofile',
        name: 'personalprofile',
        component: PersonalProfile,
      }, {
        path: 'openinvoicedetail',
        name: 'openinvoicedetail',
        component: OpenInvoiceDetail,
      },

      // {
      //   path: '/layout',
      //   redirect: '/layout/home'
      // }
    ]
  },
  {
    path: '/protocolmanagement',
    name: 'protocolmanagement',
    component: ProtocolManagement
  },
  {
    path: '/protocol',
    name: 'protocol',
    component: Protocol
  },


]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const mainStore = useMainStore();
  next()
})

export default router
